const pageNameKey = "otaConfigurationInstallModal";

export const otaConfigurationInstallModalEn = {
  [pageNameKey]: {
    installingConfigurationText: "Installing Configuration",
    installConfigurationOnDeviceText: "Installing configuration on device",
    descriptionText:
      "This may take a few minutes. Please do not close this window while the configuration installation is in progress.",
    configurationText: "Configuration",
    versionText: "Version",
    digestText: "Digest",
    sizeText: "Size",
    progressText: "Progress:",
    configurationInstallationCompleted: "Configuration installation completed",
    configurationInstallationFailed: "Configuration installation failed",
    installationTimeoutFailed: "Installation timeout. Please check device.",
  },
};

export const otaConfigurationInstallModalPtBr = {
  [pageNameKey]: {
    installingConfigurationText: "Instalando configuração",
    installConfigurationOnDeviceText: "Instalando configuração no dispositivo",
    descriptionText:
      "Isso pode levar alguns minutos. Não feche esta janela enquanto a instalação da configuração estiver em andamento.",
    configurationText: "Configuração",
    versionText: "Versão",
    digestText: "Hash",
    sizeText: "Tamanho",
    progressText: "Progresso:",
    configurationInstallationCompleted: "Instalação da configuração concluída",
    configurationInstallationFailed: "Falha na instalação da configuração",
    installationTimeoutFailed:
      "Tempo limite de instalação. Verifique o dispositivo.",
  },
};

export const otaConfigurationInstallModalDe = {
  [pageNameKey]: {
    installingConfigurationText: "Konfiguration wird installiert",
    installConfigurationOnDeviceText:
      "Konfiguration wird auf dem Gerät installiert",
    descriptionText:
      "Dies kann einige Minuten dauern. Bitte schließen Sie dieses Fenster nicht, während die Konfigurationsinstallation läuft.",
    configurationText: "Konfiguration",
    versionText: "Version",
    digestText: "Digest",
    sizeText: "Größe",
    progressText: "Fortschritt:",
    configurationInstallationCompleted:
      "Konfigurationsinstallation abgeschlossen",
    configurationInstallationFailed:
      "Konfigurationsinstallation fehlgeschlagen",
    installationTimeoutFailed:
      "Installationszeitüberschreitung. Bitte überprüfen Sie das Gerät.",
  },
};

export const otaConfigurationInstallModalZhHans = {
  [pageNameKey]: {
    installingConfigurationText: "正在安装配置",
    installConfigurationOnDeviceText: "正在设备上安装配置",
    descriptionText: "这可能需要几分钟。配置安装过程中请不要关闭此窗口。",
    configurationText: "配置",
    versionText: "版本",
    digestText: "摘要",
    sizeText: "大小",
    progressText: "进度：",
    configurationInstallationCompleted: "配置安装完成",
    configurationInstallationFailed: "配置安装失败",
    installationTimeoutFailed: "安装超时。请检查设备。",
  },
};

export const otaConfigurationInstallModalIt = {
  [pageNameKey]: {
    installingConfigurationText: "Installazione della configurazione",
    installConfigurationOnDeviceText:
      "Installazione della configurazione sul dispositivo",
    descriptionText:
      "Potrebbe richiedere alcuni minuti. Non chiudere questa finestra durante l'installazione della configurazione.",
    configurationText: "Configurazione",
    versionText: "Versione",
    digestText: "Hash",
    sizeText: "Dimensione",
    progressText: "Progresso:",
    configurationInstallationCompleted:
      "Installazione della configurazione completata",
    configurationInstallationFailed:
      "Impossibile completare l'installazione della configurazione",
    installationTimeoutFailed:
      "C'è stato un timeout durante l'installazione. Controlla il dispositivo.",
  },
};

export const otaConfigurationInstallModalEs = {
  [pageNameKey]: {
    installingConfigurationText: "Instalando configuración",
    installConfigurationOnDeviceText:
      "Instalando la configuración en el dispositivo",
    descriptionText:
      "Esto puede tardar unos minutos. No cierres esta ventana mientras la instalación de la configuración está en curso.",
    configurationText: "Configuración",
    versionText: "Versión",
    digestText: "Hash",
    sizeText: "Tamaño",
    progressText: "Progreso:",
    configurationInstallationCompleted:
      "Instalación de la configuración completada",
    configurationInstallationFailed: "Error al instalar la configuración",
    installationTimeoutFailed:
      "Tiempo de espera de instalación agotado. Verifica el dispositivo.",
  },
};

export const otaConfigurationInstallModalNl = {
  [pageNameKey]: {
    configurationInstallationCompleted: "Configuratie-installatie voltooid",
    configurationInstallationFailed: "Configuratie-installatie mislukt",
    configurationText: "Configuratie",
    descriptionText:
      "Dit kan enkele minuten duren. Sluit dit venster niet terwijl de configuratie wordt geïnstalleerd.",
    digestText: "Digest",
    installConfigurationOnDeviceText:
      "Configuratie wordt op het apparaat geïnstalleerd",
    installationTimeoutFailed: "Installatietime-out. Controleer het apparaat.",
    installingConfigurationText: "Nieuwe configuratie vrijgeven",
    progressText: "Voortgang:",
    sizeText: "Grootte",
    versionText: "Versie",
  },
};

export const otaConfigurationInstallModalTr = {
  [pageNameKey]: {
    configurationInstallationCompleted: "Yapılandırma kurulumu tamamlandı",
    configurationInstallationFailed: "Yapılandırma kurulumu başarısız oldu",
    configurationText: "Yapılandırma",
    descriptionText:
      "Bu birkaç dakika sürebilir. Lütfen konfigürasyon kurulumu devam ederken bu pencereyi kapatmayın.",
    digestText: "Özet",
    installConfigurationOnDeviceText: "Yapılandırmanın cihaza yüklenmesi",
    installationTimeoutFailed:
      "Kurulum zaman aşımı. Lütfen cihazı kontrol edin.",
    installingConfigurationText: "Yapılandırmanın Yüklenmesi",
    progressText: "İlerlemek:",
    sizeText: "Boyut",
    versionText: "Sürüm",
  },
};
